<div *ngIf="!this.consumoId">
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div class="entry-4-modal">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'consumos.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'consumos.filters.campanya' | translate}}</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'global.municipio' | translate}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'consumos.filters.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'consumos.filters.confeccion' | translate}}</label>
                <app-filterable-list [itemsList]="confecciones" [selectedItem]="filtersForm.get('confeccion')"
                    [disabled]="disabledConfecciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'global.almacen' | translate}}</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="finca">
            </div>
            <div class="entry-4-modal">
                <label>{{'consumos.filters.productor' | translate}}</label>
                <input type="text" formControlName="productor">
            </div>
            <div class="entry-4-modal">
                <label>{{'consumos.filters.codigoSNC' | translate}}</label>
                <input type="text" formControlName="codigoSNC">
            </div>
            <div class="entry-4-modal calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div class="entry-4-modal calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
</div>
<div class="table-wrapper" style="margin: 1.5em 0 2em; max-width: 95vw;">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th *ngIf="!this.consumoId">
                        <input type="checkbox" id="all" [checked]="allChecked" (click)="selectAll($event.target.checked)">
                        <label for="all"></label>
                    </th>
                    <th class="id">{{'mantenimientoIncidencias.consumosTable.id' | translate}}</th>
                    <th class="string">{{'mantenimientoIncidencias.consumosTable.etiquetador' | translate}}</th>
                    <th class="string">{{'global.finca' | translate}}</th>
                    <th class="string">{{'mantenimientoIncidencias.consumosTable.productor' | translate}}</th>
                    <th class="string">{{'mantenimientoIncidencias.consumosTable.confeccion' | translate}}</th>
                    <th class="date">{{'mantenimientoIncidencias.consumosTable.fechaConsumo' | translate}}</th>
                    <th class="string">{{'mantenimientoIncidencias.consumosTable.codigoSNC' | translate}}</th>
                    <th class="number">{{'global.unidades' | translate}}</th>
                    <th class="number">{{'mantenimientoIncidencias.consumosTable.kilos' | translate}}</th>
                </tr>
            </thead>
            <tbody *ngFor="let consumo of consumos; let i = index">
                <tr>
                    <td *ngIf="!this.consumoId">
                        <input type="checkbox" [id]="'consumo_'+i" [checked]="getChecked(consumo.id)"
                            (click)="selectConsumo(consumo, $event.target.checked)">
                        <label [for]="'consumo_'+i"></label>
                    </td>
                    <td class="id">{{consumo.id}}</td>
                    <td class="string">{{consumo.desEtiquetador}}</td>
                    <td class="string">{{consumo.desFinca}}</td>
                    <td class="string">{{consumo.desProductor}}</td>
                    <td class="string">{{consumo.desConfeccion ? consumo.desConfeccion : consumo.desConfeccionCampo}}</td>
                    <td>{{consumo.fechaImpresion | date: 'shortDate' : undefined : defaultLanguage}}</td>
                    <td>{{consumo.seriadoFijo}} ({{('0000' + consumo.seriadoInicio).slice(-4)}} -
                        {{( '0000' + consumo.seriadoFin).slice(-4)}})</td>
                    <td class="number">{{consumo.numeroEtiquetasImpresas  | number : '1.0-0': defaultLanguage}}</td>
                    <td class="number">{{consumo.kilosImpresosTotales  | number : '1.2-2': defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!consumos || (consumos && consumos.length < 1)">
                <tr>
                    <td colspan="11">
                        {{'global.noContent' | translate}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
<app-paginator *ngIf="(consumos && consumos.length > 0) && !this.consumoId"
    [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1" [totalItems]="totalItems"
    [visiblePages]="visiblePages" (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
</app-paginator>
